export enum ShotProblemCode {
    CUSTOMER_CANCELLATION = "1",
    WEATHER_CANCELLATION = "2",
    TECHNICAL_PROBLEM = "3",
}
